// extracted by mini-css-extract-plugin
export default {"meals":"AvaliableMeals_meals__blfY6","meals-appear":"AvaliableMeals_meals-appear__iLfxU"};